export default Object.freeze({
  CONCILIATION_AGREEMENT: 'Acuerdo Conciliación',
  MEDIATION_AGREEMENT: 'Acuerdo Mediación',
  JUDGE_ORDER: 'Orden del Juez',
});
